// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tablecellforleavereqTable{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9;
  

}

.leavereqTableCell {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9;
    margin-left: 60px;

}

.LeaveMain {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9;
   
}
.tabsize{
    width: 20px !important;
}

.css-1n5wzqn-MuiButtonBase-root-MuiTab-root{
    min-width: 40px !important
}


/* .mainFrame {
    background-color: white;
    height: 600px;
} */


.LeavereqTableButton {
    width:100%;
    max-width: 207px !important;
    height: 39px;
    border-radius: 3px;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 700 !important;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-align: center;
    background-color: #FE602F !important;
    color: white !important
}
/* 
.jobType {
    font-family: "Inter";
    font-size: 14px;
    font-weight: 700 !important;
    line-height: 17px;
    letter-spacing: 0.02em;
    text-align: left;

} */

.withdrawLeaveButton{
    width: 80% !important;
height: 39px !important;
/* padding: 10px, 20px, 10px, 20px */
border-radius: 3px !important;
background-color: #FE602F !important;
color: #FFFFFF !important;
font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19px !important;
letter-spacing: 0.02em !important;
text-align: center !important;
text-transform: capitalize !important;

}


.MuiBarElement-root{
    width: 8px !important;
    align-items: center !important;

    /* margin-left: 20px !important; */
    /* padding-left: 15px !important; */
    
}

.css-1qdzy9k-MuiBarElement-root{
    fill: #0070E9 !important;
}


.barChartParent{
    padding-left: 3%;
}


.doughnutchart1data{
    font-family: "Inter";
font-size: 26px;
font-weight: 700;
line-height: 31.47px;
letter-spacing: 0.02em;
text-align: left;
color:#00B562

}
.doughnutchart2data{
    font-family: "Inter";
font-size: 26px;
font-weight: 700;
line-height: 31.47px;
letter-spacing: 0.02em;
text-align: left;
color:#009596

}
.doughnutchart3data{
    font-family: "Inter";
font-size: 26px;
font-weight: 700;
line-height: 31.47px;
letter-spacing: 0.02em;
text-align: left;
color:#F47216

}
.doughnutchart4data{
    font-family: "Inter";
font-size: 26px;
font-weight: 700;
line-height: 31.47px;
letter-spacing: 0.02em;
text-align: left;
color:#f4c145

}

.doughnutchart5data{
    font-family: "Inter";
font-size: 26px;
font-weight: 700;
line-height: 31.47px;
letter-spacing: 0.02em;
text-align: left;
color:#AA5486

}

.doughnutchart6data{
    font-family: "Inter";
font-size: 26px;
font-weight: 700;
line-height: 31.47px;
letter-spacing: 0.02em;
text-align: left;
color:#2271b1

}
`, "",{"version":3,"sources":["webpack://./src/views/panel/LeaveManagement/leaveManagement.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;;;AAGlB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;;AAElB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;;AAGA;;;GAGG;;;AAGH;IACI,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC;AACJ;AACA;;;;;;;;;GASG;;AAEH;IACI,qBAAqB;AACzB,uBAAuB;AACvB,oCAAoC;AACpC,6BAA6B;AAC7B,oCAAoC;AACpC,yBAAyB;AACzB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,6BAA6B;AAC7B,qCAAqC;;AAErC;;;AAGA;IACI,qBAAqB;IACrB,8BAA8B;;IAE9B,kCAAkC;IAClC,mCAAmC;;AAEvC;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,gBAAgB;AACpB;;;AAGA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA;;AAEA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA","sourcesContent":[".tablecellforleavereqTable{\n    font-family: \"Inter\";\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9;\n  \n\n}\n\n.leavereqTableCell {\n    font-family: \"Inter\";\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9;\n    margin-left: 60px;\n\n}\n\n.LeaveMain {\n    font-family: \"Inter\";\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 22px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9;\n   \n}\n.tabsize{\n    width: 20px !important;\n}\n\n.css-1n5wzqn-MuiButtonBase-root-MuiTab-root{\n    min-width: 40px !important\n}\n\n\n/* .mainFrame {\n    background-color: white;\n    height: 600px;\n} */\n\n\n.LeavereqTableButton {\n    width:100%;\n    max-width: 207px !important;\n    height: 39px;\n    border-radius: 3px;\n    font-family: \"Inter\";\n    font-size: 16px;\n    font-weight: 700 !important;\n    line-height: 19px;\n    letter-spacing: 0.02em;\n    text-align: center;\n    background-color: #FE602F !important;\n    color: white !important\n}\n/* \n.jobType {\n    font-family: \"Inter\";\n    font-size: 14px;\n    font-weight: 700 !important;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    text-align: left;\n\n} */\n\n.withdrawLeaveButton{\n    width: 80% !important;\nheight: 39px !important;\n/* padding: 10px, 20px, 10px, 20px */\nborder-radius: 3px !important;\nbackground-color: #FE602F !important;\ncolor: #FFFFFF !important;\nfont-family: \"Inter\" !important;\nfont-size: 16px !important;\nfont-weight: 600 !important;\nline-height: 19px !important;\nletter-spacing: 0.02em !important;\ntext-align: center !important;\ntext-transform: capitalize !important;\n\n}\n\n\n.MuiBarElement-root{\n    width: 8px !important;\n    align-items: center !important;\n\n    /* margin-left: 20px !important; */\n    /* padding-left: 15px !important; */\n    \n}\n\n.css-1qdzy9k-MuiBarElement-root{\n    fill: #0070E9 !important;\n}\n\n\n.barChartParent{\n    padding-left: 3%;\n}\n\n\n.doughnutchart1data{\n    font-family: \"Inter\";\nfont-size: 26px;\nfont-weight: 700;\nline-height: 31.47px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#00B562\n\n}\n.doughnutchart2data{\n    font-family: \"Inter\";\nfont-size: 26px;\nfont-weight: 700;\nline-height: 31.47px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#009596\n\n}\n.doughnutchart3data{\n    font-family: \"Inter\";\nfont-size: 26px;\nfont-weight: 700;\nline-height: 31.47px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#F47216\n\n}\n.doughnutchart4data{\n    font-family: \"Inter\";\nfont-size: 26px;\nfont-weight: 700;\nline-height: 31.47px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#f4c145\n\n}\n\n.doughnutchart5data{\n    font-family: \"Inter\";\nfont-size: 26px;\nfont-weight: 700;\nline-height: 31.47px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#AA5486\n\n}\n\n.doughnutchart6data{\n    font-family: \"Inter\";\nfont-size: 26px;\nfont-weight: 700;\nline-height: 31.47px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#2271b1\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
